<!-- <canvas #canvas id="canvas" (window:resize)="onResize()"></canvas> -->
<canvas #canvas id="canvas" width="1024" height="1024"></canvas>
